import { NavLink } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { toTitleCase } from '../../utils/format';

const NAV = [
  { to: '/admin/dashboard',   icon: '⊞', label: 'Dashboard'   },
  { to: '/admin/courses',     icon: '📚', label: 'Courses'     },
  { to: '/admin/instructors', icon: '👤', label: 'Instructors' },
  { to: '/admin/students',    icon: '◈', label: 'Students'    },
  { to: '/admin/settings',    icon: '⚙️', label: 'Settings'    },
];

function initials(name = '') {
  return name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
}

export default function Sidebar({ open = false, onClose = () => {} }) {
  const { user, logout } = useAuth();

  return (
    <aside className={`sb${open ? ' open' : ''}`}>
      <div className="sb-logo">
        <div className="sb-mark">
          <svg viewBox="0 0 14 14" fill="none">
            <polygon points="7,1 13,13 1,13" fill="#0C0B09" />
          </svg>
        </div>
        <div className="sb-brand">AI <span>Foundry</span></div>
        <button onClick={onClose} style={{ marginLeft: 'auto', background: 'none', border: 'none', color: '#5A5650', cursor: 'pointer', fontSize: 18, padding: '2px 4px', display: 'none' }} className="sb-close">✕</button>
      </div>

      <div className="sb-sec">
        <div className="sb-lbl">Administration</div>
        {NAV.map(n => (
          <NavLink
            key={n.to}
            to={n.to}
            className={({ isActive }) => `sb-link${isActive ? ' on' : ''}`}
            onClick={onClose}
          >
            <span className="ic">{n.icon}</span>
            {n.label}
          </NavLink>
        ))}
      </div>

      <div className="sb-foot">
        <div className="av" style={{ background: 'var(--orange)', color: 'white', flexShrink: 0 }}>
          {user ? initials(user.full_name) : 'AD'}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="av-name">{toTitleCase(user?.full_name || 'Admin')}</div>
          <div className="av-role">Super Admin</div>
        </div>
        <button
          onClick={logout}
          title="Log out"
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#5A5650', padding: '4px',
            borderRadius: 4, lineHeight: 1, flexShrink: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            transition: 'color 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.color = '#F8F7F3'}
          onMouseLeave={e => e.currentTarget.style.color = '#5A5650'}
        >
          <svg viewBox="0 0 24 24" fill="none" width="17" height="17" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 3h5a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-5" />
            <line x1="10" y1="12" x2="2" y2="12" />
            <polyline points="6 8 2 12 6 16" />
          </svg>
        </button>
      </div>
    </aside>
  );
}
